import React, { Component } from "react";
import PieChart, {
  Series,
  Label,
  Connector,
  SmallValuesGrouping,
  Legend,
  Export,
  Tooltip,
} from "devextreme-react/pie-chart";
import apiAxios from "../../api-axios";
import UserInfo from "../../UserInfo";
import {
  Chart,
  Series as SeriesStack,
  Legend as ChartLegend,
  Export as ChartExport,
  Tooltip as ChartTooltip,
  CommonSeriesSettings,
  SeriesTemplate,
} from "devextreme-react/chart";
import "./styles.scss";

export default class AnaliseGraficos extends Component {
  constructor() {
    super();
    this.state = {
      origemPorDia: [],
      porOrigem: [],
    };
    this.formatLabel = this.formatLabel.bind(this);
    this.formatLabelChart = this.formatLabelChart.bind(this);
    this.customizeTooltip = this.customizeTooltip.bind(this);
    this.customizeTooltipChart = this.customizeTooltipChart.bind(this);
  }

  componentDidMount() {
    apiAxios
      .get(`dam/dsgraficos/${UserInfo.getPrefeitura()}`)
      .then((response) => {
        if (response.status === 200) {
          this.setState(response.data);
        }
      });
  }

  formatLabel(arg) {
    return `${arg.argumentText}: R$ ${arg.percentText}`;
  }

  formatLabelChart(arg) {
    return `${arg.valueText}`;
  }

  customizeTooltip(arg) {
    return {
      text: `${arg.argumentText}: ${arg.percentText}`,
    };
  }

  customizeTooltipChart(arg) {
    if (isNaN(Date.parse(arg.argumentText))) {
      return {
        text: `${arg.argumentText}: ${arg.valueText}`,
      };
    } else {
      return {
        text: `${arg.valueText}`,
      };
    }
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <div className={"div-graficos"}>
          <div style={{ width: "100%" }}>
            <Chart
              id="chart"
              dataSource={this.state.porOrigem}
              title="Valor arrecadado por origem"
            >
              <SeriesStack
                valueField="valor"
                argumentField="origem"
                ignoreEmptyPoints={true}
                type="bar"
                color="#000080"
              ></SeriesStack>
              <ChartTooltip
                enabled={true}
                format={{ style: "currency", currency: "BRL" }}
                customizeTooltip={this.customizeTooltipChart}
              />
              <ChartLegend
                visible={false}
                horizontalAlignment="center"
                verticalAlignment="bottom"
              />
              <ChartExport enabled={true} />
            </Chart>
          </div>
          <div style={{ width: "100%" }}>
            <PieChart
              id="pie"
              dataSource={this.state.porOrigem}
              palette="Bright"
              title="Valor arrecadado"
            >
              <Series argumentField="origem" valueField="valor">
                <Label
                  visible={true}
                  customizeText={this.formatLabel}
                  format="fixedPoint"
                  connector={{ visible: true }}
                >
                  <Connector visible={false} width={0.5} />
                </Label>
                <SmallValuesGrouping
                  threshold={1.0}
                  mode="smallValueThreshold"
                />
              </Series>
              <Tooltip
                enabled={true}
                format="percent"
                customizeTooltip={this.customizeTooltip}
              />
              <Legend horizontalAlignment="center" verticalAlignment="bottom" />
              <Export enabled={true} />
            </PieChart>
          </div>
        </div>
        <br />
        <Chart
          id="chart"
          title="Arrecadação diária"
          dataSource={this.state.origemPorDia}
        >
          <CommonSeriesSettings
            argumentField="dataDeposito"
            valueField="valor"
            type="stackedBar"
          >
            <Label
              visible={true}
              customizeText={this.formatLabelChart}
              wordWrap={true}
              format={{ style: "currency", currency: "BRL" }}
            />
          </CommonSeriesSettings>
          <SeriesTemplate nameField="valor"></SeriesTemplate>
          <ChartTooltip
            enabled={true}
            format={{ style: "currency", currency: "BRL" }}
            customizeTooltip={this.customizeTooltipChart}
          />
          <ChartLegend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="top"
          />
          <ChartExport enabled={true} />
        </Chart>
      </div>
    );
  }
}
